import React, { useState, useEffect } from 'react';
import { DateRangePicker, CustomProvider } from 'rsuite';
import dayjs from 'dayjs';
import { Box } from '@mui/material';

// Ensure the CSS is loaded
import enUS from 'rsuite/locales/en_US';
import 'rsuite/dist/rsuite-no-reset.min.css';

const RangeFilter = ({ dateRange, setDateRange, width = 230, ranges = [], weekStart = 0 }) => {
  // Use a local state for the UI to handle the 'half-selected' state smoothly
  const [tempValue, setTempValue] = useState(null);

  // Sync local UI value with parent props
  useEffect(() => {
    if (dateRange.startDate && dateRange.endDate) {
      setTempValue([
        dayjs(dateRange.startDate).toDate(),
        dayjs(dateRange.endDate).toDate()
      ]);
    } else {
      setTempValue(null);
    }
  }, [dateRange]);

  const handleOnChange = (val) => {
    setTempValue(val); // Update local UI immediately

    if (!val) {
      setDateRange({ startDate: null, endDate: null });
    } else if (val[0] && val[1]) {
      // Only update the parent state when BOTH dates are selected
      setDateRange({
        startDate: dayjs(val[0]).startOf('day'),
        endDate: dayjs(val[1]).endOf('day')
      });
    }
  };

  return (
    <Box sx={{ 
      display: 'flex', 
      alignItems: 'center',
      // This ensures rsuite popup z-index is higher than MUI table headers
      '& .rs-picker-daterange-menu': { zIndex: 9999 } 
    }}>
      <CustomProvider locale={enUS} weekStart={weekStart}>
        <DateRangePicker
          format="MMM dd, yyyy"
          character=" - "
          placeholder="Select Date Range"
          value={tempValue}
          onChange={handleOnChange}
          shouldDisableDate={(date) => dayjs(date).isAfter(dayjs(), 'day')}
          cleanable={true}
          preventOverflow={true}
          oneTap={false} 
          style={{ width: width }}
          ranges={ranges}
        />
      </CustomProvider>
    </Box>
  );
};

export default RangeFilter;